import { Product, ProductFallback } from './legolandApiTypes';

export const productsFallback: Record<string, ProductFallback[]> = {
  'https://api.move.tomtom.com': [
    {
      id: 'ja',
      displayName: 'Junction Analytics',
      redirectLink: 'https://ja.tomtom.com/',
    },
    {
      id: 'od',
      displayName: 'O/D Analysis',
      redirectLink: 'https://od.tomtom.com/dashboard',
    },
    {
      id: 'rer',
      displayName: 'Road Event Reporter',
      redirectLink: 'https://rer.tomtom.com/',
    },
    {
      id: 'ctm',
      displayName: 'Route Monitoring',
      redirectLink: 'https://route-monitoring.tomtom.com',
    },
    {
      id: 'ts',
      displayName: 'Traffic Stats',
      redirectLink: 'https://ts.tomtom.com',
    },
  ],
  'https://preprod.api.move.tomtom.com': [
    {
      id: 'ja',
      displayName: 'Junction Analytics',
      redirectLink: 'https://test.ja.tomtom.com/',
    },
    {
      id: 'od',
      displayName: 'O/D Analysis',
      redirectLink: 'https://preprod.od.tomtom.com/',
    },
    {
      id: 'rer',
      displayName: 'Road Event Reporter',
      redirectLink: 'https://test.rer.tomtom.com/',
    },
    {
      id: 'ctm',
      displayName: 'Route Monitoring',
      redirectLink: 'http://brda-01.ttg.global:8098/',
    },
    {
      id: 'ts',
      displayName: 'Traffic Stats',
      redirectLink: 'https://preprod.ts.tomtom.com',
    },
  ],
  'https://test.api.move.tomtom.com': [
    {
      id: 'ja',
      displayName: 'Junction Analytics',
      redirectLink: 'https://preprod.ja.tomtom.com/',
    },
    {
      id: 'od',
      displayName: 'O/D Analysis',
      redirectLink: 'https://preprod.od.tomtom.com/',
    },
    {
      id: 'rer',
      displayName: 'Road Event Reporter',
      redirectLink: 'https://test.rer.tomtom.com/',
    },
    {
      id: 'ctm',
      displayName: 'Route Monitoring',
      redirectLink: 'http://brda-01.ttg.global:8098/',
    },
    {
      id: 'ts',
      displayName: 'Traffic Stats',
      redirectLink: 'https://preprod.ts.tomtom.com',
    },
  ],
};

export function validateProductsFallback(
  apiUrl: string,
  actualProducts: Product[],
) {
  const errors: string[] = [];
  const envFallback = productsFallback[apiUrl];

  if (envFallback) {
    for (let product of actualProducts) {
      const fallback = envFallback.find(p => product.id === p.id);
      if (!fallback) {
        errors.push(`Fallback for product "${product.id}" is not present.`);
        continue;
      }
      for (let key of Object.keys(fallback) as (keyof ProductFallback)[]) {
        if (fallback[key] !== product[key]) {
          errors.push(
            `There is a difference in the value of "${key}" for product "${product.id}". Fallback: "${fallback[key]}", API: "${product[key]}".`,
          );
        }
      }
    }
  } else {
    errors.push(`Fallback for API "${apiUrl}" is not present.`);
  }

  if (errors.length > 0) {
    console.error(
      `Fallback values for products in API ${apiUrl} are out of date! ` +
        `Please update them in legoland-sdk in fallbackData.ts:\n\n` +
        errors.map(e => ` * ${e}\n`).join(''),
    );
  }
}
